<template>
  <form @submit.prevent="onSubmit">
    <div class="flex flex-wrap mb-6 -mx-3">
      <div class="w-full md:w-1/2 mb-6 md:mb-0 px-3">
        <label class="block mb-2 font-semibold" for="contact-name">Name *</label>
        
        <input
          type="text"
          v-model="name"
          id="contact-name"
          placeholder="Jane Doe"
          name="name"
          class="block w-full border shadow rounded-lg outline-none mb-2 p-4"
          required
        >
      </div>

      <div class="w-full px-3 md:w-1/2">
        <label
          class="block font-semibold mb-2"
          for="contact-email"
        >Email Address *</label>
        
        <input
          type="email"
          v-model="email"
          id="contact-email"
          placeholder="email@domain.com"
          name="email"
          class="block w-full border shadow rounded-lg outline-none mb-2 p-4"
          required
        >
      </div>
    </div>

    <div class="w-full mb-12">
      <label
        class="block font-semibold mb-2"
        for="contact-message"
      >Message *</label>
      
      <textarea
        id="contact-message"
        v-model="message"
        rows="4"
        name="message"
        class="block w-full border shadow rounded-lg outline-none appearance-none mb-2 px-4 py-6"
        placeholder="Your message goes here"
        required
      ></textarea>
    </div>

    <div class="flex items-center justify-end w-full">
      <div class="mr-4">
        <div v-if="response == 'success'" class="font-bold text-xl text-green-dark">
          Email has been sent!
        </div>
        <div v-if="response == 'error'" class="font-bold text-xl text-red">
          Error sending email. Please try again!
        </div>
      </div>
      <button v-show="!loading"
        type="submit"
        class="btn bg-blue hover:bg-blue-dark rounded-lg"
      >Submit</button>
      <div v-show="loading" class="font-bold text-xl">
        Sending email...
      </div>
    </div>
  </form>
</template>
<script>
export default {
  name: "Contact",
  props: ["mailto"],
  data() {
    return {
      name: '',
      email: '',
      message: '',
      loading: false,
      response: 'empty' 
    }
  },
  methods: {
    onSubmit() {
      this.loading = true;
      this.response = 'empty';
      axios.post('/contact.php', {
        name: this.name,
        email: this.email,
        message: this.message
      }).then((response) => {
        this.loading = false;
        this.response = 'success';
        this.clearForm()
      }).catch((error) => {
        this.loading = false;
        this.response = 'error';
      });
    },
    clearForm() {
      this.email = '';
      this.message = '';
      this.name = '';
    }
  }
};
</script>
